module.exports = __webpack_public_path__ + "img/yes.58013c08.svg";